import axios from 'axios';
import { Response } from '../../../../setup/axios/HttpResponse';
import { API_URL } from '../../../utils/common/constants';
import {
  CreateZatcaIntegrationRequest,
  RenewZatcaIntegrationRequest,
  ZatcaIntegrationStatus,
  ZatcaOnboardingPrefill,
} from '../models/ZatcaIntegration';

const PaymentsApi = {
  getZatcaIntegrationStatus(): Promise<Response<ZatcaIntegrationStatus>> {
    const url = `${API_URL}/api/v1/zatca-integration`;
    return axios.get(url);
  },
  getZatcaOnboardingPrefill(): Promise<Response<ZatcaOnboardingPrefill>> {
    const url = `${API_URL}/api/v1/zatca-integration/prefill`;
    return axios.get(url);
  },
  createZatcaIntegration(payload: CreateZatcaIntegrationRequest): Promise<Response<ZatcaIntegrationStatus>> {
    const url = `${API_URL}/api/v1/zatca-integration`;
    return axios.post(url, payload);
  },
  renewZatcaIntegration(payload: RenewZatcaIntegrationRequest): Promise<Response<ZatcaIntegrationStatus>> {
    const url = `${API_URL}/api/v1/zatca-integration/renew`;
    return axios.post(url, payload);
  },
};

export { PaymentsApi };
